<template>
  <div :class="$style.page">
    <Background />
    <Search />
    <Hot />
    <RightNav />
  </div>
</template>

<script>
// @ is an alias to /src
import Background from "./components/Background.vue";
import Search from "./components/Search.vue";
import Hot from "./components/Hot.vue";
import RightNav from "@components/RightNav.vue";

export default {
  name: "DomainRegister",
  components: {
    Background,
    Search,
    Hot,
    RightNav,
  },
};
</script>

<style lang="scss" module scoped>
.page {
  overflow: overlay;
}
</style>
